/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { PropertyListSelector } from 'components/selectors/propertyListSelector';
import { EndpointParameterSelector } from 'components/selectors/endpointParameterSelector';
import CommonKnobsContainer from 'views/common/commonKnobsContainer';
import { Tab, Tabs } from '@blueprintjs/core';
import { WidgetBooleanSelector } from 'components/selectors/widgetBooleanSelector';
import { ColorSelector } from 'components/selectors/colorSelector';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param cardIndex
 * @param endpointQuery
 * @param widgetConfiguration
 * @param types
 * @returns {*}
 * @constructor
 */
export const ClusterGraphKnobs = ({ cardIndex, endpointQuery, widgetConfiguration, types }) => {
	return (
		<Tabs>
			<Tab
				id="data"
				title="Data"
				panel={
					<React.Fragment>
						<CommonKnobsContainer>
							<PropertyListSelector
								cardIndex={cardIndex}
								itemIndex={0}
								flags={[SrsPropertyFlag.Multivalued]}
								types={types}
								label={'Primary Property'}
								endpointQuery={endpointQuery}
								cy-test="primary-property-dropdown-button"
							/>
						</CommonKnobsContainer>
						<CommonKnobsContainer>
							<WidgetBooleanSelector
								cardIndex={cardIndex}
								label={'Size Nodes by Connection Count'}
								propertyName={'sizeByConnection'}
								widgetConfiguration={widgetConfiguration}
							/>
						</CommonKnobsContainer>
						<CommonKnobsContainer>
							<EndpointParameterSelector
								cardIndex={cardIndex}
								label={'Minimum Connections Required'}
								values={[1, 5, 10, 100, 1000]}
								defaultValue={1}
								optionToString={(item) => String(item)}
								optionToValue={(item) => item}
								endpointQuery={endpointQuery}
								propertyName={'minConnections'}
							/>
							<EndpointParameterSelector
								cardIndex={cardIndex}
								label={'Maximum Nodes'}
								values={[10, 100, 1000, 2000, 4000, 6000, 10000, 100000]}
								defaultValue={1000}
								optionToString={(item) => String(item)}
								optionToValue={(item) => item}
								endpointQuery={endpointQuery}
								propertyName={'maxNodes'}
							/>
						</CommonKnobsContainer>
					</React.Fragment>
				}
			/>
			<Tab
				id="style"
				title="Style"
				panel={
					<React.Fragment>
						<CommonKnobsContainer>
							<ColorSelector
								cardIndex={cardIndex}
								widgetConfiguration={widgetConfiguration}
								activeItem={widgetConfiguration?.colorScale}
								cy-test="color-using-dropdown-button"
							/>
						</CommonKnobsContainer>
					</React.Fragment>
				}
			/>
		</Tabs>
	);
};
